import React from 'react';

import { Modal, Form, Input, Checkbox, Button, Space, InputNumber, Select, Divider } from 'antd';
import { layout, tailLayout, formStyle } from 'containers/common/layout';

interface IProps {
    dataId: number,
    editorVisible: boolean,
    editorTitle: string,
    onCancel: any,
}

const { Option } = Select;


class MemberPwdEdit extends React.Component<IProps> {
    constructor(props: any) {
        super(props);
    }

    cancelModal = () => {
        this.props.onCancel();
    }

    onFinish = (values: any) => {
        console.log('Success:', values);
    };

    onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };

    render() {
        return (
            <div>
                <Modal
                    title={this.props.editorTitle}
                    visible={this.props.editorVisible}
                    onCancel={this.cancelModal}
                    footer={null}
                    destroyOnClose={true}
                    maskClosable={false}
                >
                    <Form
                        {...layout}
                        name="basic"
                        initialValues={{ remember: true }}
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                        size="large"
                        style={formStyle}
                    >
                        <Form.Item
                            label="新密码"
                            name="newpassword"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label="重复新密码"
                            name="re_newpassword"
                            rules={[{ required: true, message: 'Please input!' }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Divider />

                        <Form.Item {...tailLayout}>
                            <Space size="large">
                                <Button onClick={this.cancelModal}>取消</Button>
                                <Button type="primary" htmlType="submit">确认提交</Button>
                            </Space>

                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default MemberPwdEdit;